export const Amc = (props) => {
    return (
        <div className="plan" id="amc">
            <div className="container">
                <div className="jumbo-box2 cd">
                    <h2> Annual Maintenance Contract (AMC) For Domestic RO</h2>
                    <p>We understand that regular maintenance of your water purifier can feel like an added expense, which is why we offer flexible and affordable RO AMC plans tailored to your needs. Under our AMC services, our trained technicians provide scheduled servicing, thorough system cleaning, and preventive maintenance to keep your purifier running efficiently. With multiple cost-effective plans to choose from, you can select the one that best suits your usage and budget. Investing in an RO AMC not only ensures consistent water quality but also extends the life of your purifier, saving you money in the long run.</p>
                </div>
                <div className="abt-form text-center">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>AMC Plan 1</th>
                                    <th>AMC Plan 2</th>
                                    <th>AMC Plan 3</th>
                                    <th>AMC Plan 4</th>
                                    <th>AMC Plan 5</th>
                                    <th>AMC Plan 6</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="info">
                                    <td>Service</td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                </tr>
                                <tr className="success">
                                    <td>Filters</td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                </tr>
                                <tr className="warning">
                                    <td>Membrane</td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                </tr>
                                <tr className="danger">
                                    <td>Electrical Parts</td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                </tr>
                                <tr className="primary">
                                    <td>Faulty Parts</td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/cross.png" alt="not available" /></td>
                                    <td><img src="img/sign/mark.png" alt="available" /></td>
                                </tr>
                                <tr className="warning">
                                    <td>Price</td>
                                    <td>Rs. 999</td>
                                    <td>Rs. 2500</td>
                                    <td>Rs. 2450</td>
                                    <td>Rs. 4000</td>
                                    <td>Rs. 5000</td>
                                    <td>Rs. 6000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <h3>Terms &amp; Conditions</h3>
                1. The AMC contract is valid for a period of 12 months.<br />
                2. One-time membrane replacement is included under the AMC.<br />
                3. Cabinet and tap are not covered under the AMC.<br />
                4. Three periodic services are provided on demand; any additional visits will be arranged upon request.<br />
                5. AMC plans may vary based on the brand and condition of the water purifier.<br />
                6. Only genuine spare parts are used for all services and replacements.<br />
            </div>
        </div>
    )
}